import React, { useState, useEffect } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { config } from "../../config/config";
import Tablestyles from "../../screens/Mapping/ROCITable.module.css";
import Loader from "../Loader/Loader";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

const Row = ({ keys, rowData, headingRow, sourceData }) => {
  let data = rowData;

  const Color_Details = {
    Passed: {
      color: "green",
      bg: "rgba(0, 128, 0, 0.2)",
    },
    Success: {
      color: "green",
      bg: "rgba(0, 128, 0, 0.2)",
    },
    "In Progress": {
      color: "#eb367f",
      bg: "rgba(235, 54, 127, 0.2)",
    },
    Failed: {
      color: "red",
      bg: "rgba(255, 0, 0, 0.2)",
    },
    Pending: {
      color: "orange",
      bg: "rgba(255, 165, 0, 0.2)",
    },
  };

  // const Color_Details = sourceData?.data?.dropdown?.Save_Call_Audit_Log_Color_Details || {}

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      className={"table-row"}
      style={{ cursor: "pointer" }}
    >
      {headingRow.map(({ label, value }, index) => (
        <>
          <StyledTableCell
            key={`key-${index}`}
            className={""}
            style={{
              position: "relative",
              height: "45px",
              padding: "2px 3px 2px 10px",
              whiteSpace: "nowrap",
              textWrap: "wrap",
              cursor: "pointer",
            }}
          >
            {value !== "IS_VALIDATION" && value !== "STATUS" && (
              <span>
                {data[value] && typeof data[value] === "object"
                  ? JSON.stringify(data[value])
                  : data[value] || "None"}
              </span>
            )}

            {value === "IS_VALIDATION" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <span
                  style={{
                    color: Color_Details[data[value]]?.color || "gray",
                    backgroundColor:
                      Color_Details[data[value]]?.bg || "transparent",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    width: "fit-content",
                  }}
                >
                  {data[value] && typeof data[value] === "object"
                    ? JSON.stringify(data[value])
                    : data[value] || "None"}
                </span>
                {data[value] === "In Progress" && (
                  <Loader
                    style={{
                      color: Color_Details[data[value]]?.color || "gray",
                    }}
                  />
                )}
              </div>
            )}

            {value === "STATUS" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <span
                  style={{
                    color: Color_Details[data[value]]?.color || "gray",
                    backgroundColor:
                      Color_Details[data[value]]?.bg || "transparent",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    width: "fit-content",
                  }}
                >
                  {data[value] && typeof data[value] === "object"
                    ? JSON.stringify(data[value])
                    : data[value] || "None"}
                </span>
                {data[value] === "In Progress" && (
                  <Loader
                    style={{
                      color: Color_Details[data[value]]?.color || "gray",
                    }}
                  />
                )}
              </div>
            )}
          </StyledTableCell>
        </>
      ))}
    </TableRow>
  );
};

export const SaveCallAuditLogs = ({ sourceData }) => {
  // Table State's
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginatedRows, setPaginatedRows] = useState([]);
  const TableData = sourceData?.data?.dropdown?.SAVE_CALL_AUDIT_RESULTS || [];
  const TableHeader =
    sourceData?.data?.dropdown?.audit_header_column_list || [];

  const handlePaginatedRows = (newPage) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = TableData.slice(start, end);
    return currentPageRows;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage);
    setPaginatedRows(Paginated_Rows);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = TableData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  useEffect(() => {
    setPaginatedRows(TableData.slice(0, rowsPerPage));
  }, [TableData]);

  return (
    <>
      <TableContainer className={Tablestyles.budget_tb3}>
        <Table stickyHeader className={""}>
          <TableHead className="table-heading">
            <TableRow className={""}>
              {TableHeader.map(({ label, value }, i) => (
                <StyledTableCell key={i}>{label}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row, index) => (
              <Row
                keys={index}
                rowData={row}
                headingRow={TableHeader}
                sourceData={sourceData}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {!TableData.length && (
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          No History and Logs found!
        </div>
      )}

      {/* Pagination */}
      {TableData.length > 0 && (
        <div>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={TableData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};
